module.exports = __webpack_public_path__ + "img/52_45.5363fcdd.png";